import axios from 'axios';

const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const runtimeProtocol = typeof window !== 'undefined' ? window.location.protocol : 'http:';
const defaultBaseUrl = `${runtimeProtocol}//${runtimeHost}:3000/api`;

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || defaultBaseUrl,
});

// Interceptor um Token an jeden Request zu haengen
API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

export default API;
